import {ResolvedNewJoiner} from "../../api/ResolvedNewJoinerStore";
import {NewJoinerOperations} from "./NewJoinerApi";
import React, {useMemo} from "react";
import {ChecklistGroup} from "./NewJoinerChecklistItem";
import {Box, IconButton, Link, Stack, Typography} from "@mui/material";
import NeighbourhoodColorIcon from "../../components/neighbourhood-icon/NeighbourhoodColorIcon";
import RemoveIcon from "@mui/icons-material/Close";
import {ChecklistItemCategory} from "../../api/Model";
import {showOverflowOnHoverSx} from "../../components/overflow-on-hover/ShowOverflowOnHover";

export function NeighbourhoodChecklistGroup({newJoiner, operations}: {
    newJoiner: ResolvedNewJoiner,
    operations: NewJoinerOperations,
}) {
    const toggles = useMemo(
        () => operations.checklistToggles[ChecklistItemCategory.Neighbourhood],
        [operations.checklistToggles],
    );

    return (
        <ChecklistGroup
            nestedToggles={toggles}
            disabled={!newJoiner.employee}
            headerChecked={operations.neighbourhoods.length > 0}
        >{operations.neighbourhoods.length <= 0 ? (
            newJoiner.employee && operations.handleSelectNeighbourhoodClick ? (
                <Link onClick={operations.handleSelectNeighbourhoodClick}>
                    Select Neighbourhood
                </Link>
            ) : (
                <Typography color="textDisabled">Select Neighbourhood</Typography>
            )
        ) : (
            <Stack direction="column" alignItems="center" width="100%">
                {operations.neighbourhoods.map((hood, hoodIndex) => (
                    <Stack key={hood.key}
                           direction="row"
                           gap={0.5}
                           alignItems="center"
                           flexWrap="nowrap"
                           width="100%"
                    >
                        <NeighbourhoodColorIcon
                            neighbourhood={hood}
                            size={20}
                            sx={{flexShrink: 0}}
                        />
                        <Box sx={{maxWidth: 'calc(100% - 48px)'}}>
                            <Typography variant="body1" sx={showOverflowOnHoverSx}>{hood.name}</Typography>
                        </Box>
                        {operations.handleClearNeighbourhoodClick && hoodIndex === operations.neighbourhoods.length - 1 && (
                            <IconButton
                                onClick={operations.handleClearNeighbourhoodClick}
                                sx={{height: 20, width: 20, flexShrink: 0}}
                                title="Remove neighbourhoods"
                            >
                                <RemoveIcon sx={{fontSize: 16, color: 'text.secondary'}}/>
                            </IconButton>
                        )}
                    </Stack>
                ))}
            </Stack>
        )}</ChecklistGroup>
    );
}
